//formik and yap
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { imagesReadyForDeliveryRequestType, imagesCheckoutRequestType } from '../../api/booking/type/BookingType';
import Button from '@mui/material/Button';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import CircularProgress from '@mui/material/CircularProgress';
import { DialogProps } from '@mui/material';
import { carBookingType } from '../../api/Cars/type/CarsType';
import { UserConsumer } from '../../hooks/context/UserContext';


const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

interface AddImgesProps {
    selectedCar: carBookingType;
    setSelectedCar: (selectedCar: carBookingType | null) => void
    setCloseDialog: (value: {open:boolean,scrollType: DialogProps['scroll']}) => void
    callFunction: (id:number, data:any) => Promise<any>
    loading: boolean
    timeFilter: string
    status: string
    setPage: (page: number) => void
    setBookingCarsData: (bookingCarsData: carBookingType[]) => void
    fetchBookings: (currentTimeFilter?: string, currentStatus?: string) => Promise<void>
    typeForAddimages: string
}

const AddImges = ({selectedCar, setSelectedCar, setCloseDialog, callFunction, loading, timeFilter, status, setPage, setBookingCarsData, fetchBookings, typeForAddimages}:AddImgesProps) => {
    const {t} = useTranslation()
    let {theme} = UserConsumer()
    const [images, setImages] = useState<any>(typeForAddimages === "prepareCheckin" 
        ? {
            checkin_exterior_1: null,
            checkin_exterior_2: null,
            checkin_exterior_3: null,
            checkin_exterior_4: null,
            checkin_exterior_5: null,
            checkin_exterior_6: null,
            checkin_exterior_7: null,
            checkin_exterior_8: null,
            checkin_odo_gas_picture: null,
            checkin_front_seats_picture: null,
            checkin_rear_seats_picture: null,
        }
        : {
        checkout_exterior_1: null,
        checkout_exterior_2: null,
        checkout_exterior_3: null,
        checkout_exterior_4: null,
        checkout_exterior_5: null,
        checkout_exterior_6: null,
        checkout_exterior_7: null,
        checkout_exterior_8: null,
        checkout_odo_gas_picture: null,
        checkout_front_seats_picture: null,
        checkout_rear_seats_picture: null,
        });

    const ReadyForDeliverySchema = Yup.object().shape(typeForAddimages === "prepareCheckin"
        ? {
            checkin_exterior_1: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkin_exterior_2: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkin_exterior_3: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkin_exterior_4: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkin_exterior_5: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkin_exterior_6: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkin_exterior_7: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkin_exterior_8: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkin_odo_gas_picture: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkin_front_seats_picture: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkin_rear_seats_picture: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        }
        :{
        checkout_exterior_1: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkout_exterior_2: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkout_exterior_3: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkout_exterior_4: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkout_exterior_5: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkout_exterior_6: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkout_exterior_7: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkout_exterior_8: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkout_odo_gas_picture: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkout_front_seats_picture: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        checkout_rear_seats_picture: Yup.mixed()
            .required(t("front_mechanic_image_required"))
            .test("fileType", t("invalid_file_type"), (value) => {
            if (!value) return false;
            if (typeof value === "string") return true;
            return ["image/jpeg", "image/png", "image/jpg"].includes((value as File).type);
        }),
        }
    )
    const handleSubmit = async (values: imagesReadyForDeliveryRequestType,)=>{
        let result = await callFunction(selectedCar?.id, values);
        if(result.data) {
            setSelectedCar?.(null);
            setCloseDialog({open:false, scrollType: "paper"});
            setPage(1)
            setBookingCarsData([]);
            await fetchBookings(timeFilter, status);
        }
    }
    const checkout = async (values: imagesCheckoutRequestType,)=>{
        let result = await callFunction(selectedCar?.id, values);
        if(result.data) {
            setSelectedCar?.(null);
            setCloseDialog({open:false, scrollType: "paper"});
            setPage(1)
            setBookingCarsData([]);
            await fetchBookings(timeFilter, status);
        }
    }
    return (
        <div>
            <Formik
            initialValues= {
                typeForAddimages === "prepareCheckin"
                ?
                {
                    checkin_exterior_1: null,
                    checkin_exterior_2: null,
                    checkin_exterior_3: null,
                    checkin_exterior_4: null,
                    checkin_exterior_5: null,
                    checkin_exterior_6: null,
                    checkin_exterior_7: null,
                    checkin_exterior_8: null,
                    checkin_odo_gas_picture: null,
                    checkin_front_seats_picture: null,
                    checkin_rear_seats_picture: null,
                }
                :
                {
                    checkout_exterior_1: null,
                    checkout_exterior_2: null,
                    checkout_exterior_3: null,
                    checkout_exterior_4: null,
                    checkout_exterior_5: null,
                    checkout_exterior_6: null,
                    checkout_exterior_7: null,
                    checkout_exterior_8: null,
                    checkout_odo_gas_picture: null,
                    checkout_front_seats_picture: null,
                    checkout_rear_seats_picture: null,
                }
            }
         
            validationSchema={ReadyForDeliverySchema}
            onSubmit={(values) =>
                typeForAddimages === "prepareCheckin"
                ? handleSubmit(values as imagesReadyForDeliveryRequestType)
                : checkout(values as imagesCheckoutRequestType)
            }
            >
            {({ values,touched, errors,setFieldValue }) => (
                <Form>
                    <div className='flex justify-center flex-wrap gap-3 mb-5'>
                        {Object.entries(images).map(([key, value], index) => (
                            <div>
                                <div className='w-[170px] rounded-2xl border border-gray-300 shadow-lg hover:shadow-xl transition-shadow duration-300' key={key}>
                                    <Button
                                        component="label"
                                        className='!w-full !flex-wrap !rounded-b-none !p-0'
                                    >
                                        <div className={`w-full h-[50px] px-3 flex justify-center items-center !rounded-t-2xl ${selectedCar?.car.fuel_type === "electric" ? "!bg-electricColor" : theme === "client" ? "!bg-customerColor" :"!bg-paretnerColor"} !text-white !capitalize`}>
                                                <p className='text-center'>{t(`${key}`)}</p>
                                                <VisuallyHiddenInput
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(event) => {
                                                        const file = event.target.files?.[0];
                                                        if (file) {
                                                            setFieldValue(key, file)
                                                            setImages((prev: any) => ({ ...prev, [key]: URL.createObjectURL(file) }));
                                                        }
                                                    }}
                                                />
                                        </div>
                                        <div className='w-full h-[130px]'>
                                            {images[key]
                                            ?
                                                <img
                                                src={images[key]}
                                                alt="Front Mechanic Image"
                                                className="w-full !rounded-b-2xl h-full object-cover border max-sm:mx-auto"
                                                />
                                            :
                                                <div className='w-full h-full flex justify-center items-center'>
                                                    <AddAPhotoIcon className='!text-[40px] !text-gray-400'/>
                                                </div>
                                            }
                                        </div>
                                    </Button>
                                </div>
                                {touched[key as keyof typeof values] && errors[key as keyof typeof values] && (
                                    <p className="text-red-500 text-[11px] text-center mt-1">
                                        {errors[key as keyof typeof values]}
                                    </p>
                                )}
                            </div>
                        ))}
                    </div>
                    <Button className={`w-full h-[62px] ${selectedCar?.car.fuel_type === "electric" ? "!bg-electricColor" : theme === "client" ? "!bg-customerColor" :"!bg-paretnerColor"} !text-white !rounded-full`} type="submit">
                    {loading 
                    ? <CircularProgress className='w-1 h-1'/>
                    :t("confirm")
                    }
                    </Button>
                </Form>

            )}
            </Formik>
        </div>
    )
}

export default AddImges